module.exports = __webpack_public_path__ + "img/hero-image-b.5fa738d2.jpg";